module.exports = __webpack_public_path__ + "static/media/logo_changepay.79f39237.jpg";